import { render, staticRenderFns } from "./AppointmentSelectLocationPage.vue?vue&type=template&id=0572366a"
import script from "./AppointmentSelectLocationPage.vue?vue&type=script&lang=ts"
export * from "./AppointmentSelectLocationPage.vue?vue&type=script&lang=ts"
import style0 from "./AppointmentSelectLocationPage.vue?vue&type=style&index=0&id=0572366a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports